import * as React from "react";
import { Button } from "components/bootstrap";
import Routes from "routing/Routes";
const MessagePermalinkButton = ({ messageIndex, messageId }) => {
  const messageUrl = messageIndex ? Routes.message_show(messageIndex, messageId) : "#";
  return /* @__PURE__ */ React.createElement(Button, { href: messageUrl, disabled: !messageIndex, bsSize: "small" }, "Permalink");
};
export default MessagePermalinkButton;
